module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Visit Summary","note":"The summary contains only web measurement data, not apps or offline data."},"ja":{"title":"訪問サマリー","note":"サマリーにはWeb計測データのみ含まれ、アプリやオフラインデータは対象外です。"},"zh-hant":{"title":"訪問總括","note":"該總括不包括手機數據等導入的數據。"},"zh-hans":{"title":"访问总括","note":"该总括不包括手机数据与离线数据。"}}')
  delete Component.options._Ctor
}
